<template lang="pug">
span.d-inline-flex.align-items-center.order-status.justify-content-center(
  :class='`status-${status}`'
)
  | {{ displayText }}
</template>

<script>
const ORDER_STATUS_TEXT = {
  0: 'รออนุมัติ',
  1: 'อนุมัติ',
  2: 'ไม่อนุมัติ',
  3: 'UNIX',
};
const SHIPMENT_STATUS_TEXT = {
  0: 'รอจัดส่ง',
  1: 'จัดส่งแล้ว',
  2: 'ไม่อนุมัติ',
};

export default {
  props: {
    status: {
      default: 0,
    },
    type: {
      default: 'ORDER_STATUS',
    },
  },
  computed: {
    displayText() {
      switch (this.type) {
        case 'ORDER_STATUS':
          return ORDER_STATUS_TEXT[this.status];
        case 'SHIPMENT_STATUS':
          return SHIPMENT_STATUS_TEXT[this.status];
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss">
// .custom-status-badge {}
</style>
